const ARCHITECT_TOKEN_KEY = "architect-api-token";

export function getArchitectToken() {
  return window.sessionStorage.getItem(ARCHITECT_TOKEN_KEY);
}

export function setArchitectToken(token) {
  window.sessionStorage.setItem(ARCHITECT_TOKEN_KEY, token);
}

export function clearArchitectToken() {
  window.sessionStorage.removeItem(ARCHITECT_TOKEN_KEY);
}
